import { useAuthContext } from "@contexts/authContext"
import { fontSize, size } from "@styles/theme"
import styled from '@emotion/styled'
import { BrowsingButton, RightNowButton, MeetupButton, ChattingButton, RomanceButton } from '@components/nearby/StatusSelectButtons'

const StatusDescription = styled.p`
  margin: 0;
  margin-bottom: ${size(1.5)};
  padding: ${size(2)} ${size(3)};
  line-height: ${size(2.5)};
  font-size: ${fontSize('sm')};
  text-align: center;
`

const ButtonContainer = styled.div`
  padding: ${size(0.75)} ${size(1)};
`

const StatusContentSelect = ({ afterSelect }) => {
  const { state: authState } = useAuthContext()

  return(
    <>
      <StatusDescription>
        Tells nearby users what you're looking for <em>at this moment.</em> This helps attract the right attention.
      </StatusDescription>
      <ButtonContainer>
        <BrowsingButton
          isCurrent={authState?.user?.tempStatus === 'browsing'}
          afterSelect={afterSelect}
        />
      </ButtonContainer>
      <ButtonContainer>
        <RightNowButton
          isCurrent={authState?.user?.tempStatus === 'right_now'}
          afterSelect={afterSelect}
        />
      </ButtonContainer>
      <ButtonContainer>
        <MeetupButton
          isCurrent={authState?.user?.tempStatus === 'meetup'}
          afterSelect={afterSelect}
        />
      </ButtonContainer>
      <ButtonContainer>
        <ChattingButton
          isCurrent={authState?.user?.tempStatus === 'chatting'}
          afterSelect={afterSelect}
        />
      </ButtonContainer>
      <ButtonContainer>
        <RomanceButton
          isCurrent={authState?.user?.tempStatus === 'romance'}
          afterSelect={afterSelect}
        />
      </ButtonContainer>
    </>
  )
}

export default StatusContentSelect
